import RecurrenceUpdateModal from './RecurrenceUpdateModal';

export default RecurrenceUpdateModal;
